export const PASSWORD_REGEX =
  '^(?=.*?[A-Za-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*_-]).{8,}$'
